import React from "react";

export const LogoInactive: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="29"
    height="16"
    viewBox="0 0 29 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.0335 0H15.6622V3.2428H22.0335C22.4774 3.2428 22.9027 3.32063 23.2973 3.46332L15.6622 11.3141V6.86826C15.6633 3.08175 12.5384 0 8.69678 0H2.32544V3.2428H8.69678C9.14068 3.2428 9.56594 3.32063 9.96052 3.46332L0 13.7069L2.32654 16L12.2195 5.82624C12.3203 6.15701 12.3751 6.50723 12.3751 6.86934V16H15.6633L25.5562 5.82624C25.657 6.15701 25.7119 6.50723 25.7119 6.86934V16H29V6.86934C29 3.08175 25.8752 0 22.0346 0H22.0335Z"
      fill="currentColor"
    />
  </svg>
);
